// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "सर्वेक्षण का वर्ष",
    "note": "*इस समीक्षा के सभी आंकड़े 2025/12/31 तक के हैं।"
  },
  "handCard": {
    "text": "{date}\nआपने 2025 में पहली बार NUTS POKER खेला।"
  },
  "report": {
    "loginTime": "तब से, NUTS POKER \n{loginDay} \nतक आपके साथ रहा है।",
    "loginTips": "*साल 2025 के वो दिन जब आपने NUTS POKER में लॉग इन किया।",
    "enjoyTime": "{loginTime}\nआपके लिए दिन का सबसे आनंददायक समय है! NUTS POKER खोलने का यह आपका पसंदीदा समय है!",
    "firstHandDate": "{first_hand_date}\n{first_hand_type} खेलते हुए आपको साल का पहला हाथ मिला।\n{first_hand_cards}"
  },
  "hands": {
    "v1": "इस साल NUTS POKER में, आपने कुल\n{hands}\nखेले पोकर के प्रति आपका प्यार \n{percentage} खिलाड़ियों में सबसे अधिक है।",
    "v2": "इस साल NUTS POKER में, आपने कुल\n{hands}\nहमारी यात्रा का हिस्सा बनने के लिए शुक्रिया!",
    "v3": "इस साल NUTS POKER में, आपने कुल \n{hands}\nNUTS POKER अगले साल आपको और भी बेहतर अनुभव देने की कोशिश करेगा।"
  },
  "hardTime": {
    "date": "{one_day_hands}\nयह NUTS POKER पर आपका सबसे समर्पित दिन था।",
    "hands": "आपने कुल\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "आपके द्वारा खेले गए हाथों की कुल संख्या में से,\n{handsNum} {hands} आपके जिस पसंदीदा गेम फॉर्मेट में खेले गए थे वो है {game}।",
  "kkWin": {
    "v1": "2025 में, आपने कुल\n{all} {longTimes}\nऔर अपने विरोधियों को KK से\n{win} {longTimesTwo}",
    "v2": "इस साल आपने\n{all} {threeTimes}\nआपकी ऑल-इन जीत की दर है:\n{percentage}\nपोकर साहसी लोगों का खेल है!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nआपका सबसे भाग्यशाली दिन था। उस दिन",
    "spinup_2": "आपको स्पिनअप में {spinup_ratio} मल्टीप्लायर मिला और आपने\n{spinup_reward}\nजीता।",
    "mtt": "{mtt_date}\nवर्ष का आपका मुख्य आकर्षण था।",
    "mtt_2": "उस दिन,\nआप {mtt_name} में नंबर {mtt_rank} पर थे\nऔर जीते\n{mtt_reward}",
    "rg": "{rg_date}\nआपकी पोकर यात्रा में एक उल्लेखनीय दिन!",
    "rg_2": "आपने साल का सबसे बड़ा पॉट जीता:\n{rg_reward}"
  },
  "lucky": {
    "title": "हर हाथ एक\nअलग कहानी बताता है।",
    "luckyHand": "लकी\nहाथ",
    "unLuckyHand": "अनलकी\nहाथ",
    "luckyRate": "जीत दर\n{lucky_rate}",
    "unLuckyRate": "जीत दर\n{unlucky_rate}",
    "luckyText": "{lucky_hand} ने हीरो का रोल निभाया है।\nजब यह आपके पास था, तो आप {lucky_rate} बार जीते!",
    "unLuckyText": "{unlucky_hand} से सावधान रहें…\nआप इसके साथ केवल {unlucky_rate} बार ही जीते।",
    "note": "*केवल वही शुरुआती हाथ योग्य हैं जिन्हें 10 बार या उससे अधिक बार डील किया गया हो।"
  },
  "futureStory": "NUTS POKER 2026 में भी आपके साथ आपकी पोकर यात्रा की कहानी लिखने के लिए उत्सुक है।",
  "version3": {
    "text": "दुर्भाग्य से, आपने 2025 में NUTS POKER के साथ कोई यादें नहीं छोड़ीं।",
    "continue": "2026 में अपनी NUTS POKER यात्रा का\nअगला चैप्टर हमारे साथ लिखें!",
    "tips": " *सभी आंकड़े 2024-12-31 तक के हैं।"
  },
  "button": {
    "save": "छवि सहेजें",
    "copy": "कॉपी और साझा करें"
  },
  "unit": {
    "days": "दिनों",
    "hands": "हाथ",
    "longHands": "हाथ खेले।",
    "longTimes": "बार KK प्राप्त किया",
    "longTimesTwo": "बार हराया।",
    "threeTimes": "बार ऑल-इन किया",
    "times": "बार",
    "multiplier": "मल्टीप्लायर ",
    "num": "",
    "num2": "",
    "bets": "दांव लगाए।",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "लिंक कॉपी हुआ",
    "imageSaved": "छवि सहेजी गयी"
  }
}
  